module.exports = __webpack_public_path__ + "Verlag-Book.otf?ea144141cb709880612a4ec9348c2d7c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/verlag/Verlag-Book.otf
// module id = 309
// module chunks = 0